import React from "react";
import { NavLink } from "react-router-dom";
import NativeInterface from "../../services/NativeInterface"
import AuthContext from '../../store/AuthContext';

import { BiSolidCamera } from 'react-icons/bi';
import { IoHomeOutline, IoHomeSharp } from "react-icons/io5";
import { BsInfoCircle, BsFillInfoCircleFill } from 'react-icons/bs';
import { IoMap, IoMapOutline } from "react-icons/io5";
import { IoPersonOutline, IoPersonSharp } from "react-icons/io5";
import { useLanguage } from "pages/dimension/LanguageContext";

import "./DimensionFooter.css";
interface DimensionFooterProps {
    dimId: string,
    active?: string,
    onChange?: (value: string) => void;
}

const DimensionFooter: React.FC<DimensionFooterProps> = (props) => {
    const authCtx = React.useContext(AuthContext);
    const langCtx = useLanguage();
    const [tab, setTab] = React.useState<string>(props.active? props.active : 'main');

    function handleLiveView() {
        NativeInterface.launchNativeApp({});
    }

    const onItemClick = (tab: string) => {
        setTab(tab)
        props.onChange?.(tab)
    }

    return (
        <div className="dimension-footer-main">
            <div className={`dimension-footer-nav-item ${tab == 'main' ? 'active' : ''}`}
                onClick={() => onItemClick('main')}>
                {/*tab == 'main' ? <IoHomeSharp/> : <IoHomeOutline/>*/}
                <img src={authCtx.makeFileUrl(props.dimId, 'icon.png')} alt="icon" className="dimension-footer-icon" />
                <span>{langCtx.translate('Home')}</span>
            </div>

            <div className={`dimension-footer-nav-item ${tab == 'info' ? 'active' : ''}`}
                onClick={() => onItemClick('info')}>
                {tab == 'info' ? <BsFillInfoCircleFill/> : <BsInfoCircle/>}
                <span>{langCtx.translate('Info')}</span>
            </div>

            {NativeInterface.isPWA() && (
                <div className="dimension-footer-nav-item middle" onClick={handleLiveView}>
                    <div className="camera-btn">
                        <BiSolidCamera className="camera-icon"/>
                    </div>
                </div>
            )}

            <div className={`dimension-footer-nav-item ${tab == 'map' ? 'active' : ''}`}
                onClick={() => onItemClick('map')}>
                {tab == 'map' ? <IoMap/> : <IoMapOutline/>}
                <span>{langCtx.translate('Map')}</span>
            </div>

            <div className={`dimension-footer-nav-item ${tab == 'account' ? 'active' : ''}`}
                onClick={() => onItemClick('account')}>
                {tab == 'account' ? <IoPersonSharp /> : <IoPersonOutline />}
                <span>{langCtx.translate('Profile')}</span>
            </div>
        </div>
    );
};

export default DimensionFooter;
